var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg_gray" }),
    _c(
      "div",
      { staticClass: "shoppingCart" },
      [
        _c("van-nav-bar", {
          attrs: {
            title: "购物车",
            "right-text": _vm.cartStateText,
            border: false,
            fixed: "",
            "safe-area-inset-top": ""
          },
          on: { "click-right": _vm.onClickRight }
        }),
        _vm.goods.length
          ? _vm._l(_vm.goods, function(item, index) {
              return _c("div", { key: item.id, staticClass: "contentBox" }, [
                _c("input", {
                  staticClass: "checkBox",
                  attrs: { type: "checkbox", name: "checkBoxTest" },
                  domProps: { checked: item.checked },
                  on: {
                    click: function($event) {
                      return _vm.singleSelect(item, index)
                    }
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "commodityImg",
                    on: {
                      click: function($event) {
                        return _vm.singleSelect(item, index)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/pic_shop_ popup1@2x.png"),
                        alt: ""
                      }
                    })
                  ]
                ),
                _c("div", { staticClass: "commodityInfo" }, [
                  _c("h2", { staticClass: "van-ellipsis" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _c("span", [_vm._v(_vm._s(item.weight) + "克+简易包装")]),
                  _c("div", { staticClass: "countMoney  flex_between" }, [
                    _c("div", { staticClass: "money" }, [
                      _vm._v(
                        "¥" +
                          _vm._s(
                            +item.pricehj * +item.weight * item.stepperValue
                              ? (
                                  +item.pricehj *
                                  +item.weight *
                                  item.stepperValue
                                ).toFixed(2)
                              : 0
                          )
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "count" },
                      [
                        _c("van-stepper", {
                          attrs: {
                            min: "1",
                            max: "5",
                            "input-width": "40px",
                            "button-size": "26px",
                            "disable-input": ""
                          },
                          model: {
                            value: item.stepperValue,
                            callback: function($$v) {
                              _vm.$set(item, "stepperValue", $$v)
                            },
                            expression: "item.stepperValue"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            })
          : _vm._e(),
        !_vm.goods.length
          ? [
              _c("van-empty", {
                staticClass: "custom-image",
                attrs: {
                  image: require("@/assets/images/pic_no goods@2x.png"),
                  description: "空空如也！快去选购你喜欢的商品吧"
                }
              })
            ]
          : _vm._e()
      ],
      2
    ),
    _c("div", { staticClass: "totalGoods" }, [
      _c("input", {
        staticClass: "checkBoxAll",
        attrs: { type: "checkbox", name: "checkBoxTestAll" },
        domProps: { checked: _vm.isAllSelected },
        on: { click: _vm.allSelect }
      }),
      _c("span", { staticClass: "selectAllText" }, [_vm._v("全选")]),
      _vm.cartState
        ? _c("div", { staticClass: "total" }, [
            _c("div", { staticClass: "totalMoney" }, [
              _vm._v(
                " 合计: ¥" +
                  _vm._s(_vm.totalMoney ? _vm.totalMoney.toFixed(2) : 0.0) +
                  " "
              )
            ]),
            _c("div", { staticClass: "totalWeight" }, [
              _vm._v(" 克重: " + _vm._s(_vm.totalWeight.toFixed(2)) + "g ")
            ])
          ])
        : _vm._e(),
      _vm.cartState
        ? _c("div", { staticClass: "jieSuan" }, [
            _vm._v(" 去结算(" + _vm._s(_vm.settlement) + ") ")
          ])
        : _vm._e(),
      !_vm.cartState
        ? _c("div", { staticClass: "delete", on: { click: _vm.deleteData } }, [
            _vm._v("删除")
          ])
        : _vm._e()
    ]),
    _c("footer", { staticClass: "foot" }, [
      _c("div", { staticClass: "flex-around" }, [
        _c("div", { on: { click: _vm.linkMall } }, [
          _vm._m(0),
          _c("div", { staticClass: "footerText" }, [_vm._v("商城")])
        ]),
        _c("div", { on: { click: _vm.linkCart } }, [
          _vm._m(1),
          _c("div", { staticClass: "footerText" }, [_vm._v("购物车")])
        ]),
        _c("div", { on: { click: _vm.linkMy } }, [
          _vm._m(2),
          _c("div", { staticClass: "footerText" }, [_vm._v("我的")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icon_mall-nor@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/icon_trolley_sel@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerboximg" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/icon_personal_nor@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }